@if (config$ | async; as config) {
  <navigation
    [headerClass]="headerClass"
    [config]="{
      icons: config.icons,
      links: config.links,
      dropdown: toolbarConfig$ | async,
      logoUrl: config.logoUrl,
      showCoBrandLogo: config.showCoBrandLogo,
      hideToolbar: config.hideToolbar,
      languagesSwitcher: config.languagesSwitcher,
      isLogoUrlExternal: config.isLogoUrlExternal,
    }"
    [externalSiteModalConfig]="externalSiteModalConfig"
    [data]="{
      isUserLoggedIn: isLoggedIn,
      isMobileMenuOpen: isMobileMenuOpen$ | async,
      openMenuItem: openMenuItem$ | async,
      activeNavItem: activeNavItem$ | async,
      iconData: icons$ | async,
    }"
    [activeLangKey]="activeLangKey"
    (navMenuToggled)="toggleNavMenu($event)"
    (navItemClicked)="navItemClick($event)"
    (dropdownOptionSelected)="toolbarOptionClick($event)"
    (mobileMenuToggled)="toggleMobileMenu($event)"
    (logoutClicked)="logout()"
    (loginClicked)="toggleMobileMenu(false)"
    (languageSwitched)="handleLanguageSwitched($event)"
  >
  </navigation>
}
